(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Explicit Tab-cycling safeguard: verified by direct testing that this environment's browser does
    // not always keep Tab focus contained inside an open <dialog> shown via showModal() (focus can
    // escape to <body> from the dialog's last focusable element even while the dialog is still open).
    // Rather than rely solely on native modal focus containment, wrap Tab/Shift+Tab explicitly at the
    // dialog's own first/last focusable element whenever it is open.
    function trapFocus(dialog, event) {
      if (event.key !== 'Tab') {
        return;
      }
      var focusable = dialog.querySelectorAll(
        'a[href], button:not(:disabled), summary, [tabindex]:not([tabindex="-1"])',
      );
      if (focusable.length === 0) {
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    // Idempotent, scoped initializer: normal storefront page loads call this once against the whole
    // document (unchanged behavior). The Theme Editor can also replace this section's markup via an
    // AJAX section reload without a full page reload, which would otherwise leave a newly-inserted
    // trigger/dialog pair with no listeners at all (not duplicated — simply never wired). The
    // data-sc-nav-ready marker makes repeat calls against the same scope safe: an already-wired
    // trigger is skipped, so listeners are never stacked.
    function initHeaderNav(scope) {
      scope
        .querySelectorAll('[data-sc-nav-toggle]:not([data-sc-nav-ready])')
        .forEach(function (trigger) {
          var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!dialog || typeof dialog.showModal !== 'function') {
            return;
          }
          trigger.setAttribute('data-sc-nav-ready', 'true');

          trigger.addEventListener('click', function () {
            dialog.showModal();
            trigger.setAttribute('aria-expanded', 'true');
          });

          dialog.addEventListener('keydown', function (event) {
            trapFocus(dialog, event);
          });

          dialog.addEventListener('close', function () {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          });
        });
    }

    initHeaderNav(document);

    // Shopify's documented Theme Editor lifecycle event: fires with the reloaded section's own root
    // element as event.target whenever a section is added/re-rendered in the editor's live preview.
    // Scoping the re-scan to event.target (not the whole document) only re-initializes what actually
    // changed. Normal storefront visitors never trigger this event at all.
    document.addEventListener('shopify:section:load', function (event) {
      initHeaderNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
